export const addressTypes = {
    LIST_REQUEST: 'Addresses list - request',
    LIST_SUCCESS: 'Addresses list - success',
    LIST_ERROR: 'Addresses list - error',

    ADDRESS_LOAD_REQUEST: 'exists address - request to load ',
    ADDRESS_LOAD_SUCCESS: 'exists address - loaded',
    ADDRESS_LOAD_ERROR: 'exists address - empty',

    ADDRESS_SAVE_REQUEST: 'exists address - request to save ',
    ADDRESS_SAVE_SUCCESS: 'exists address - saved',
    ADDRESS_SAVE_ERROR: 'exists address - failed',

    ADDRESS_NEW_ADD_LOADED: 'new address - ready ',
    ADDRESS_NEW_ADD_REQUEST: 'new address - request to save ',
    ADDRESS_NEW_ADD_SUCCESS: 'new address - added',
    ADDRESS_NEW_ADD_ERROR: 'new address - not added',

    ADDRESS_DELETE_REQUEST: 'exists address - request to delete ',
    ADDRESS_DELETE_SUCCESS: 'exists address - deleted',
    ADDRESS_DELETE_ERROR: 'exists address - not deleted',

    CLEAR: 'address clear',
};
